
  function initSizeOptions(){
    const maxRows = 2;

    document.querySelectorAll('.size-options--wrap').forEach(function(wrap) {
      const ul = wrap.querySelector('.size-options');
      if (!ul) return;

      const liElements = Array.from(ul.children);
      if (liElements.length === 0) return;

      const rowHeight = liElements[0].offsetHeight;
      if (!rowHeight) return;

      // Determine the number of rows
      let totalRows = 1;
      let lastTop = liElements[0].offsetTop;
      liElements.forEach(li => {
        if (li.offsetTop > lastTop) {
          totalRows++;
          lastTop = li.offsetTop;
        }
      });

      // If it fits in 2 rows, we do nothing.
      if (totalRows <= maxRows) return;

      // Find the last element in the 2nd row
      let lastIndex2Row = 0;
      for (let i = 0; i < liElements.length; i++) {
        if (liElements[i].offsetTop < rowHeight * maxRows) {
          lastIndex2Row = i;
        } else {
          break;
        }
      }

      const hiddenItems = liElements.slice(lastIndex2Row); // include all elements after 2 rows

      // Hide all elements after 2 rows
      hiddenItems.forEach(li => {
        li.style.display = 'none';
        li.classList.add('hidden-by-js');
      });

      // Create +N and insert it after the last element of the 2nd row
      const showMoreLi = document.createElement('li');
      showMoreLi.className = 'show-more cursor-pointer';
      showMoreLi.textContent = `+${hiddenItems.length}`;
      showMoreLi.style.userSelect = 'none';
      ul.insertBefore(showMoreLi, hiddenItems[0]);

      // Click on +N - show all hidden and delete +N
      showMoreLi.addEventListener('click', function() {
        hiddenItems.forEach(li => li.style.display = 'inline-flex');
        showMoreLi.remove();
      });
    });
  }

document.addEventListener('DOMContentLoaded', initSizeOptions);


const grid = document.getElementById('product-grid');
if (grid) {
  const observer = new MutationObserver(mutations => {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        initSizeOptions();
      }
    }
  });

  observer.observe(grid, { childList: true, subtree: true });
}


document.addEventListener('DOMContentLoaded', () => {
    const filter = document.querySelector('#filter-main-open-close');
    if (filter && filter.hasAttribute('open')) {
      filter.removeAttribute('open');
    }
});

/*document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".rd-item--input").forEach(item => {
    const checkbox = item.querySelector('input[name="filter.p.m.custom.on_sale"]');
    if (checkbox) {
      const detailsUtils = item.closest("details-utils");
      if (detailsUtils) {
        detailsUtils.classList.add("rd-on--sale");
        //detailsUtils.querySelector("details").setAttribute("open", "");
      }
    }
  });
});*/

function markOnSale() {
  document.querySelectorAll(".rd-item--input").forEach(item => {
    const checkbox = item.querySelector('input[name="filter.p.m.custom.on_sale"]');
    if (checkbox) {
      const detailsUtils = item.closest("details-utils");
      if (detailsUtils && !detailsUtils.classList.contains("rd-on--sale")) {
        detailsUtils.classList.add("rd-on--sale");
      }
    }
  });
}


document.addEventListener("DOMContentLoaded", markOnSale);


const filtersContainer = document.querySelector("#filters-container"); 
if (filtersContainer) {
  const observer = new MutationObserver(markOnSale);
  observer.observe(filtersContainer, { childList: true, subtree: true });
}


// #on-sale-checkbox
// document.querySelector('input[name="filter.p.m.custom.on_sale"]').click();

/////////////////////////////////////////////


document.addEventListener("click", (e) => {
  const target = e.target.closest('.rd-show--results');
  if (!target) return;

  const trigger = document.querySelector('[aria-controls="filter-main-open-close"]');
  if (trigger) trigger.click();
});



/*document.addEventListener("DOMContentLoaded", () => {
  const clearAll = document.getElementById("RDClearAll");
  function checkFiltersInUrl() {
    const url = window.location.href;
    const hasFilters =
      url.includes("sort_by") ||
      url.includes("filter.p.product_type") ||
      url.includes("filter.v.price.");
    if (hasFilters) {
      clearAll?.classList.remove("hidden");
    } else {
      clearAll?.classList.add("hidden");
    }
  }
  ["pushState", "replaceState"].forEach(method => {
    const original = history[method];
    history[method] = function () {
      const result = original.apply(this, arguments);
      window.dispatchEvent(new Event("urlchange"));
      return result;
    };
  });
  window.addEventListener("popstate", () => {
    window.dispatchEvent(new Event("urlchange"));
  });
  window.addEventListener("urlchange", checkFiltersInUrl);
  checkFiltersInUrl();
});
document.addEventListener("click", (e) => {
  const clearBtn = e.target.closest("#RDClearAll");
  if (!clearBtn) return;
  const facetClearAll = document.querySelector('a#clear-all');
  if (facetClearAll) facetClearAll.click();
  const cleanUrl = window.location.origin + window.location.pathname;
  history.replaceState({}, "", cleanUrl);
  window.dispatchEvent(new Event("urlchange"));
  clearBtn.classList.add("hidden");
});
*/

/*document.addEventListener("DOMContentLoaded", () => {
  const clearAll = document.getElementById("RDClearAll");
  let ignoreUrlCheck = false; 

  function checkFiltersInUrl() {
    if (ignoreUrlCheck) return; 

    const url = window.location.href;

    const hasFilters =
      url.includes("sort_by") ||
      url.includes("filter.p.product_type") ||
      url.includes("filter.v.price.");

    if (hasFilters) {
      clearAll?.classList.remove("hidden");
    } else {
      clearAll?.classList.add("hidden");
    }
  }

  ["pushState", "replaceState"].forEach(method => {
    const original = history[method];
    history[method] = function () {
      const result = original.apply(this, arguments);
      window.dispatchEvent(new Event("urlchange"));
      return result;
    };
  });

  window.addEventListener("popstate", () => {
    window.dispatchEvent(new Event("urlchange"));
  });

  window.addEventListener("urlchange", checkFiltersInUrl);

  checkFiltersInUrl();


  // === CLEAR ALL ===
  document.addEventListener("click", (e) => {
    const clearBtn = e.target.closest("#RDClearAll");
    if (!clearBtn) return;

    ignoreUrlCheck = true; 

    const facetClearAll = document.querySelector('a#clear-all');
    if (facetClearAll) facetClearAll.click();

    const cleanUrl = window.location.origin + window.location.pathname;
    history.replaceState({}, "", cleanUrl);

    window.dispatchEvent(new Event("urlchange"));

    clearBtn.classList.add("hidden");

    setTimeout(() => {
      ignoreUrlCheck = false;
    }, 300);
  });
});*/

document.addEventListener("DOMContentLoaded", () => {
  let ignoreUrlCheck = false;
  const FILTER_KEYS = ["sort_by", "filter.p.", "filter.v.", "filter."];

  function hasFilters() {
    const url = window.location.href;
    return FILTER_KEYS.some(k => url.includes(k));
  }

  // === .ProductCountDesktop-2-wrap ===
  function waitForWrapper(callback) {
    const wrap = document.querySelector(".ProductCountDesktop-2-wrap");
    if (wrap) {
      callback(wrap);
      return;
    }

    const observer = new MutationObserver(() => {
      const wrap = document.querySelector(".ProductCountDesktop-2-wrap");
      if (wrap) {
        observer.disconnect();
        callback(wrap);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // === Create button ===
  function ensureButton() {
    waitForWrapper(wrapper => {
      if (document.getElementById("RDClearAll")) return;

      const btn = document.createElement("div");
      btn.id = "RDClearAll";
      btn.className = "rd-clear--all cursor-pointer";
      btn.textContent = "CLEAR ALL";

      wrapper.appendChild(btn);
    });
  }

  // === Delete button ===
  function removeButton() {
    const btn = document.getElementById("RDClearAll");
    if (btn) btn.remove();
  }

  // === Check URL ===
  function checkUrl() {
    if (ignoreUrlCheck) return;

    if (hasFilters()) ensureButton();
    else removeButton();
  }

  // === history ===
  ["pushState", "replaceState"].forEach(method => {
    const orig = history[method];
    history[method] = function () {
      const out = orig.apply(this, arguments);
      window.dispatchEvent(new Event("urlchange"));
      return out;
    };
  });

  window.addEventListener("popstate", () =>
    window.dispatchEvent(new Event("urlchange"))
  );
  window.addEventListener("urlchange", checkUrl);

  checkUrl();

  // === CLEAR ALL ===
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("#RDClearAll");
    if (!btn) return;

    ignoreUrlCheck = true;

    const shopifyBtn = document.querySelector("a#clear-all");
    if (shopifyBtn) shopifyBtn.click();

    const clean = window.location.origin + window.location.pathname;
    history.replaceState({}, "", clean);

    removeButton();

    setTimeout(() => (ignoreUrlCheck = false), 200);
  });
});






